import React, { useState } from 'react';
import Datepicker from 'react-tailwindcss-datepicker';
import Dashboard from '../../pages/Dashboard';
import { datetimetodate } from '../../utilities/datetime';
import { useSelector } from 'react-redux';

const DatePicker1 = ({ value, handleValueChange }) => {

  return (
    <div className="max-w-sm mx-auto">
      <Datepicker
       primaryColor={"blue"} // highlight color
        showShortcuts={true}
        showFooter={true}
        value={value}
        // displayFormat={"YYYY/MM/DD"}
        onChange={handleValueChange}
        popoverDirection="down"
        inputClassName="w-full px-10 py-1 text-md font-bold border-2 border-blue-500 rounded-lg shadow focus:ring-2 focus:ring-blue-400 focus:border-blue-600"
      />
    </div>
  );
};

export default DatePicker1;
